import {
  changeFieldValue,
  getCheckoutPaymentFormValues,
  getQuestion,
  getSection,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, SectionsEnum } from 'app/shared/enums';
import { QuestionInterface } from 'app/shared/interfaces/Question.interface';

const consents = {
  fillAllRequiredPaymentConsents() {
    const value = getCheckoutPaymentFormValues().consent.all.payment;
    const section = getSection(
      SectionsEnum.PaymentSectionConsents,
      FormsEnum.CheckoutPaymentForm
    );

    section.questions
      .map((questionKey: FieldsEnum) =>
        getQuestion(questionKey, FormsEnum.CheckoutPaymentForm)
      )
      .filter((question: QuestionInterface) => question && question.required)
      .forEach((question: QuestionInterface) =>
        changeFieldValue(question.key, value, FormsEnum.CheckoutPaymentForm)
      );
  },
  requiredConsentChange() {
    const allConsentsQuestion = getQuestion(
      FieldsEnum.ButtonConsentsPayment,
      FormsEnum.CheckoutPaymentForm
    );

    changeFieldValue(
      allConsentsQuestion.key,
      false,
      FormsEnum.CheckoutPaymentForm
    );
  },
};

export default consents;
